/**
 * An error that is used to indicate that some code path should never be entered.  It shouldn't ever be thrown except
 * in cases of a false assumption made by the programmer or a programming logic error.
 */
export class UnreachableError extends Error {
  public constructor(message?: string) {
    super(message || 'Entered unreachable code');
  }
}
